<!-- Hero -->
<section class="sav-abp-hero">
  <div class="sav-site-container">
    <app-breadcrumb [items]="crumbs" />
  </div>
  <div class="sav-site-container sav-abp-hero-inner">
    <span class="sav-abp-eyebrow">Partner with us</span>
    <h1 class="sav-abp-title">
      Add Your Brand on SavingArena
      <app-dev-flag note="Static hero copy (form itself posts to backend)" />
    </h1>
    <p class="sav-abp-lede">
      Get your store in front of millions of deal-seekers. Submit your brand for review and our
      partnerships team will reach out to get you listed with coupons, deals, and cashback offers.
    </p>
  </div>
</section>

<section class="sav-site-container sav-abp-body">
  @if (submitted()) {
    <div class="sav-abp-success" role="status">
      <span class="sav-abp-success-icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </span>
      <h2 class="sav-abp-success-title">Thank you, your brand request has been submitted.</h2>
      <p class="sav-abp-success-text">Our team will review your submission and contact you soon.</p>
      <a routerLink="/" class="sav-abp-btn sav-abp-btn--ghost">Back to home</a>
    </div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="submitForm()" class="sav-abp-card" novalidate>
      <div class="sav-abp-card-head">
        <h2 class="sav-abp-card-title type-card-title">Submit your store</h2>
        <p class="sav-abp-card-sub">
          Fields marked <span class="sav-abp-req">*</span> are required.
        </p>
      </div>

      @if (submitError()) {
        <div class="sav-abp-alert" role="alert">{{ submitError() }}</div>
      }

      <!-- Honeypot: hidden from humans, catches bots. -->
      <div class="sav-honeypot" aria-hidden="true">
        <label
          >Company website<input
            formControlName="companyWebsite"
            type="text"
            tabindex="-1"
            autocomplete="off"
        /></label>
      </div>

      <div class="sav-abp-grid">
        <div class="sav-abp-field">
          <label class="sav-abp-label" for="storeName"
            >Brand / Store name <span class="sav-abp-req">*</span></label
          >
          <input
            id="storeName"
            formControlName="storeName"
            type="text"
            class="sav-abp-input"
            [class.sav-abp-input--error]="isInvalid('storeName')"
          />
          @if (isInvalid('storeName')) {
            <span class="sav-abp-error">Store name is required.</span>
          }
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="websiteUrl"
            >Website URL <span class="sav-abp-req">*</span></label
          >
          <input
            id="websiteUrl"
            formControlName="websiteUrl"
            type="text"
            placeholder="https://yourstore.com"
            class="sav-abp-input"
            [class.sav-abp-input--error]="isInvalid('websiteUrl')"
          />
          @if (isInvalid('websiteUrl')) {
            <span class="sav-abp-error">Enter a valid website URL.</span>
          }
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="contactName"
            >Contact person <span class="sav-abp-req">*</span></label
          >
          <input
            id="contactName"
            formControlName="contactName"
            type="text"
            class="sav-abp-input"
            [class.sav-abp-input--error]="isInvalid('contactName')"
          />
          @if (isInvalid('contactName')) {
            <span class="sav-abp-error">Contact name is required.</span>
          }
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="email"
            >Email address <span class="sav-abp-req">*</span></label
          >
          <input
            id="email"
            formControlName="email"
            type="email"
            class="sav-abp-input"
            [class.sav-abp-input--error]="isInvalid('email')"
          />
          @if (isInvalid('email')) {
            <span class="sav-abp-error">Enter a valid email address.</span>
          }
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="phone">Phone / WhatsApp</label>
          <input id="phone" formControlName="phone" type="text" class="sav-abp-input" />
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="category">Store category</label>
          <input
            id="category"
            formControlName="category"
            type="text"
            placeholder="e.g. Fashion, Electronics"
            class="sav-abp-input"
          />
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="country">Country / target market</label>
          <input id="country" formControlName="country" type="text" class="sav-abp-input" />
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="hasAffiliateProgram"
            >Affiliate program available?</label
          >
          <select
            id="hasAffiliateProgram"
            formControlName="hasAffiliateProgram"
            class="sav-abp-input"
          >
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="affiliateNetwork">Affiliate network name</label>
          <input
            id="affiliateNetwork"
            formControlName="affiliateNetwork"
            type="text"
            placeholder="e.g. Awin, CJ, Impact"
            class="sav-abp-input"
          />
        </div>

        <div class="sav-abp-field">
          <label class="sav-abp-label" for="commissionDetails">Commission details</label>
          <input
            id="commissionDetails"
            formControlName="commissionDetails"
            type="text"
            placeholder="Optional"
            class="sav-abp-input"
          />
        </div>

        <div class="sav-abp-field sav-abp-field--full">
          <label class="sav-abp-label" for="couponDealDetails">Coupon / deal details</label>
          <input
            id="couponDealDetails"
            formControlName="couponDealDetails"
            type="text"
            placeholder="Optional"
            class="sav-abp-input"
          />
        </div>

        <div class="sav-abp-field sav-abp-field--full">
          <label class="sav-abp-label" for="description">Short brand description</label>
          <textarea
            id="description"
            formControlName="description"
            rows="3"
            class="sav-abp-input"
          ></textarea>
        </div>

        <div class="sav-abp-field sav-abp-field--full">
          <label class="sav-abp-label" for="notes">Message / notes</label>
          <textarea id="notes" formControlName="notes" rows="3" class="sav-abp-input"></textarea>
        </div>

        <div class="sav-abp-field sav-abp-field--full">
          <label class="sav-abp-label" for="logo">Store logo</label>
          <input
            id="logo"
            type="file"
            accept="image/png,image/jpeg,image/webp"
            (change)="onLogoSelected($event)"
            class="sav-abp-file"
          />
          <span class="sav-abp-hint">PNG, JPG, JPEG or WEBP · max 2MB.</span>
          @if (logoName()) {
            <span class="sav-abp-ok">Selected: {{ logoName() }}</span>
          }
          @if (logoError()) {
            <span class="sav-abp-error">{{ logoError() }}</span>
          }
        </div>
      </div>

      <div class="sav-abp-actions">
        <button type="submit" class="sav-abp-btn sav-abp-btn--primary" [disabled]="submitting()">
          {{ submitting() ? 'Submitting…' : 'Submit brand request' }}
        </button>
      </div>
    </form>
  }

  <!-- Trust / benefits -->
  <section class="sav-abp-benefits" aria-label="Why partner with SavingArena">
    <h2 class="sav-abp-benefits-title">
      Why partner with SavingArena?
      <app-dev-flag note="Static benefits list (hardcoded marketing copy)" />
    </h2>
    <p>What your brand gets from being listed with us.</p>
    <div class="sav-abp-benefit-grid">
      <article class="sav-abp-benefit">
        <span class="sav-abp-benefit-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3 21h18" />
            <path d="M5 21V7l7-4 7 4v14" />
            <path d="M9 21v-6h6v6" />
          </svg>
        </span>
        <h3 class="sav-abp-benefit-title type-card-title">Millions of shoppers</h3>
        <p class="sav-abp-benefit-text">
          Reach a high-intent audience actively hunting for coupons and deals across every category.
        </p>
      </article>
      <article class="sav-abp-benefit">
        <span class="sav-abp-benefit-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
          </svg>
        </span>
        <h3 class="sav-abp-benefit-title type-card-title">Fast, free listing</h3>
        <p class="sav-abp-benefit-text">
          No upfront cost. Submit once and our team handles the setup of your store page and offers.
        </p>
      </article>
      <article class="sav-abp-benefit">
        <span class="sav-abp-benefit-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m12 2 2.4 7.4H22l-6 4.4 2.3 7.2L12 16.6 5.7 21l2.3-7.2-6-4.4h7.6z" />
          </svg>
        </span>
        <h3 class="sav-abp-benefit-title type-card-title">Boost brand trust</h3>
        <p class="sav-abp-benefit-text">
          A verified presence with real coupons builds credibility and drives repeat purchases.
        </p>
      </article>
      <article class="sav-abp-benefit">
        <span class="sav-abp-benefit-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3 3v18h18" />
            <path d="m19 9-5 5-4-4-4 4" />
          </svg>
        </span>
        <h3 class="sav-abp-benefit-title type-card-title">Grow your sales</h3>
        <p class="sav-abp-benefit-text">
          Turn deal-seekers into customers with featured placements during peak shopping events.
        </p>
      </article>
    </div>
  </section>
</section>
